import { defineStore } from 'pinia'

const isProduction = import.meta.env.MODE === 'production'
const baseURL = isProduction ? 'https://test.gaskeunrelawan.com/api/' : 'http://127.0.0.1:8000/api/'
// Enum for theme types
export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}
interface Alert {
  message: string
  status: string
}

export const useUtilsStore = defineStore('utils', {
  state: () => ({
    isMinimized: false,
    isTheme: Theme.LIGHT as Theme,
    isMessage: [] as Alert[],
    isAlert: false,
    isStatus: true,
    autoCloseTimer: null as number | null,
    isLoading: true,
    isOnline: navigator.onLine,
    baseURL: baseURL,
  }),
  actions: {
    toogleSidebar() {
      this.isMinimized = !this.isMinimized
    },
    toogleTheme(payload: Theme) {
      const theme = payload || this.isTheme
      localStorage.setItem('theme', theme)
      if (theme === Theme.SYSTEM) {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        this.isTheme = prefersDark ? Theme.DARK : Theme.LIGHT
        localStorage.setItem('theme', this.isTheme)
      } else {
        this.isTheme = theme
      }
    },
    toggleAlert(message: string, status: string) {
      this.isAlert = true
      if (message) {
        this.isMessage.push({ message, status })
      }
      if (!this.autoCloseTimer) {
        this.startAutoClose()
      }
    },
    toogleCloaseAlert(index: number) {
      this.isMessage.splice(index, 1)
      if (this.isMessage.length === 0) {
        this.isAlert = false // Sembunyikan alert jika tidak ada pesan lagi
      }
    },
    startAutoClose() {
      this.autoCloseTimer = setInterval(() => {
        if (this.isMessage.length > 0) {
          this.isMessage.shift() // Hapus item pertama
        }
        if (this.isMessage.length === 0) {
          this.stopAutoClose() // Hentikan interval kalau sudah kosong
        }
      }, 3500) as unknown as number // FIX: Konversi ke number
    },
    stopAutoClose() {
      if (this.autoCloseTimer !== null) {
        clearInterval(this.autoCloseTimer)
        this.autoCloseTimer = null
        this.isAlert = false
      }
    },
    toogleLoading(value: boolean) {
      this.isLoading = value
    },
    setOnlineStatus(status: boolean) {
      this.isOnline = status
    },
    listenOnlineStatus() {
      window.addEventListener('online', () => {
        this.setOnlineStatus(true)
      })
      window.addEventListener('offline', () => {
        this.setOnlineStatus(false)
      })
    },
  },
})
